export const ADDEMOJI_ICON = "/images/addEmojiIcon.svg";
